import React from 'react';
import './index.scss';
import PropTypes from 'prop-types';
import Markdown from 'markdown-to-jsx';

/**
 * Title component: renders a title within a header tag
 * @param {string} title - The title to render
 * @param {string} titleSize - The header tag to use (h1, h2, h3)
 * @param {string} classes - Any additional classes to add to the header tag
 * @param {string} cypressDataAttr - The data-cy attribute to add to the header tag
 * @returns {JSX.Element} - The title component
 */
const Title = ({
  title, titleSize, classes, cypressDataAttr,
}) => (
  <>
    {titleSize === 'h1' && <h1 className={classes} data-cy={cypressDataAttr}><Markdown>{title}</Markdown></h1>}
    {titleSize === 'h2' && <h2 className={classes} data-cy={cypressDataAttr}><Markdown>{title}</Markdown></h2>}
    {titleSize === 'h3' && <h3 className={classes} data-cy={cypressDataAttr}><Markdown>{title}</Markdown></h3>}
  </>
);

Title.defaultProps = {
  classes: '',
  cypressDataAttr: null,
};

Title.propTypes = {
  title: PropTypes.string.isRequired,
  titleSize: PropTypes.string.isRequired,
  classes: PropTypes.string,
  cypressDataAttr: PropTypes.string,
};

export default Title;
